/**
 * Hardcoded app config (from AiAgentHubReact .env).
 * Used for Cloudflare and other builds where .env is not present.
 */
export const APP_MODE: "cloud" | "development" = "cloud";

export const REACT_APP_API_URL =
  "https://fam-fin-cal-react-29853640588.us-south1.run.app/";
export const REACT_APP_DEV_URL = "http://localhost:3000";
export const REACT_APP_PRODUCTION_URL =
  "https://fam-fin-cal-react-29853640588.us-south1.run.app/";
export const FASTAPI_BASE_URL = "https://finfastapi-29853640588.us-south1.run.app/";
export const clientId =
  "29853640588-k7d6as8eod0h6992bd12b4t5acsup98i.apps.googleusercontent.com";
export const REACT_APP_GOOGLE_APPLICATION_CREDENTIALS =
  "/home/wahid/sds/creds/finbot-408300-7312be103994.json";
export const OIDC_AUDIENCE =
  "https://finfastapi-29853640588.us-south1.run.app/";
export const FORWARD_USER_TOKEN = true;

export const getFastApiBaseUrl = (withTrailingSlash = false): string => {
  const normalized = FASTAPI_BASE_URL.replace(/\/+$/, "");
  return withTrailingSlash ? `${normalized}/` : normalized;
};
